module.exports = __webpack_public_path__ + "img/no-loads.9d1386e1.png";